ACDiscountApp.CartPage.Show_CalculateTier = function () {
    let customerToGive = null;
    let first10PercentageTier = {"entity_id":"AllProducts","entity_type":"products","discount_type":"percentage","status":true,"mostPopularValues":[false],"mixmacthentityId":5869895371242,"mixMatch":false,"tier_min":[1],"tier_max":["max"],"tier_values":[10],"start_date":null,"end_date":null,"Location_Tag_":null,"DiscountAppliedON":"Online_Store","marketRegion":[],"excludeProducts":[{"id": "7918257438890","title": "The Wellness Starter Pack","handle": "the-wellness-starter-pack"},{"id": "7918257471658","title": "New Spirit Naturals Lifetime Membership","handle": "20-membership-sign-up"}]}
    let first25PercentageTier = {"entity_id":"AllProducts","entity_type":"products","discount_type":"percentage","status":true,"mostPopularValues":[false],"mixmacthentityId":5869895371242,"mixMatch":false,"tier_min":[1],"tier_max":["max"],"tier_values":[25],"start_date":null,"end_date":null,"Location_Tag_":null,"DiscountAppliedON":"Online_Store","marketRegion":[],"excludeProducts":[{"id": "7918257438890","title": "The Wellness Starter Pack","handle": "the-wellness-starter-pack"},{"id": "7918257471658","title": "New Spirit Naturals Lifetime Membership","handle": "20-membership-sign-up"}]}
    let customerMemberOrNot = globalFields.customerTagsCheck();
    const cartObjFunction = () =>{
      customerMemberOrNot = globalFields.customerTagsCheck();
      if(customerMemberOrNot == ''){
        let items = globalFieldsCartPage_AC.cartObj.items;
     const result = items.some(item => item.variant_id === 45414657687722) && items.some(item => item.variant_id === 45387575427242) ? { matched: true, amount: 25 } : items.some(item => item.variant_id === 45414657687722) ? { matched: true, amount: 25 } : items.some(item => item.variant_id === 45387575427242) ? { matched: true, amount: 10 } : items.some(item => item.id === 45414657687722 || item.id === 45387575427242) ? { matched: true, amount: 0 } : { matched: false, amount: 0 };

      if(result != null && result.matched &&  result.amount == 10){
        customerToGive = first10PercentageTier
      }else if(result != null && result.matched &&  result.amount == 25){
        customerToGive = first25PercentageTier
      }else{
        customerToGive = null
      }
      }else{
        customerToGive = null
      }
     
    }
  
let flag = false;
  // Returning from checkout restores this page from the back/forward cache with `flag` still true,
  // which would skip discount-code generation. Reset it (and re-check membership state) on restore.
  jQuery(window).on('pageshow', function (e) {
    if (e.persisted) {
      flag = false;
      if (globalFieldsCartPage_AC.cartObj) {
        cartObjFunction();
      }
    }
  });
  //  $('.cart__page .cart__checkout-wrapper button[name="checkout"]').text('\n            Check out\n')
  //      $('.cart__page .cart__checkout-wrapper button[name="checkout"]').prop('disabled', false);  
  //   $('.drawer__footer button[name="checkout"]').text('\n            Check out\n')
  //    $('.drawer__footer button[name="checkout"]').prop('disabled', false)
  var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index) {
       if (isUpdate) {
       var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
       var condition1 = updatedItemPrice == originalItemPrice;
       updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice);
       if (isNotInRange || condition1) {
       if(item.original_price == item.discounted_price){
       jQuery('.ac-main-cartlineItem').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
       }
       else{
       jQuery('.ac-main-cartlineItem').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
       }
       }
       else {
       originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice);
       if(item.original_price == item.discounted_price){
       jQuery('.ac-main-cartlineItem').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
       }
       else{
       jQuery('.ac-main-cartlineItem').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
       }
       }
       }
       jQuery('.discounts__discount').remove();
 }

 var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
     if (isUpdate) {
         updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
         if (originalTotalPrice != updatedTotalPrice) {
             jQuery('.drawer__footer .cart__item-sub div[data-subtotal]').html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
             jQuery('.cart__page .cart__item-sub.cart__item-row div[data-subtotal]').html('<s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalTotalPrice, globalFields.amount) + '</span></s> <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
         }
         else {
         jQuery('.drawer__footer .cart__item-sub div[data-subtotal]').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
         jQuery('.cart__page .cart__item-sub.cart__item-row div[data-subtotal]').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
         }
     }
 }

 var UpdateSavingMessage = function (isUpdate) {
     if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
         var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) + '</span>');
         var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
       if (jQuery(window).width() < 700) {
         jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__page .cart__item-sub.cart__item-row').after('<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
       }
       else{
         jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__page .cart__item-sub.cart__item-row').after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
       }
     }
     else if (globalFields.isCartPage) {
         jQuery('#saved-banner-div').remove();
     }
 }

  async function handleDiscount() {
      try {
        const response = await fetch("/discount/CLEAR");
    
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        const contentType = response.headers.get("Content-Type");
    
        if (contentType && contentType.includes("application/json")) {
          const data = await response.json();
          // Continue processing or updating the UI as needed
        } else {
          // Handle non-JSON content, such as HTML or other types
          // console.error("Unexpected content type:", contentType);
          // Handle specific error scenarios or display a user-friendly message
        }
      } catch (error) {
        // Handle errors
        // console.error("Error fetching discount:", error.message);
        // Handle specific error scenarios or display a user-friendly message
      }
    }
var CheckoutClickCart = function () {
    // Delegated handler: survives the cart form being re-rendered after an item is added/removed,
    // which previously dropped the binding and let checkout proceed without showing the membership popup
    jQuery(document).off('click', '.cart__page .cart__checkout-wrapper button[name="checkout"]').on('click', '.cart__page .cart__checkout-wrapper button[name="checkout"]', function (e) {
       e.preventDefault();
        let flagValue = jQuery('.cart__item-row.cart__terms #CartTerms').prop('checked');
        if (flagValue) {
            // Not a member and no membership discount available -> show the membership popup and block checkout
            if (customerToGive == null && customerMemberOrNot == '') {
                // Only block when the popup element exists in the theme, otherwise checkout would hang silently
                if ($("#main").length) {
                    $("#main").show();
                    $("#main2").hide();
                    return;
                }
            }
            // Execute these functions if flagValue is true and customerToGive is not null
             jQuery('.cart__checkout-wrapper button[name="checkout"]').text('\n            Checkout\n          ');
              jQuery('.drawer__footer button[name="checkout"],.drawer__footer .cart__checkout-wrapper button[name="checkout"]').text('\n            Checkout\n          ');
            TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
            GetCode(false);
        } else {
            // Alert when the checkbox is not checked
            alert("You must agree with the terms and conditions of sales to check out");
        }
    });
}
var CheckoutClickAjax = function () {
  // Delegated handler: survives the drawer/cart being re-rendered after an item is added/removed
  jQuery(document).off('click', '.drawer__footer button[name="checkout"],.drawer__footer .cart__checkout-wrapper button[name="checkout"]').on('click', '.drawer__footer button[name="checkout"],.drawer__footer .cart__checkout-wrapper button[name="checkout"]', function (e) {
    e.preventDefault();
    let flagValue = jQuery('.cart__item-row.cart__terms #CartTermsDrawer').prop('checked');
        if (flagValue) {
            // Not a member and no membership discount available -> show the membership popup and block checkout
            if (customerToGive == null && customerMemberOrNot == '') {
                // Only block when the popup element exists in the theme, otherwise checkout would hang silently
                if ($("#main2").length) {
                    $("#main2").show();
                    $("#main").hide();
                    return;
                }
            }
            // Execute these functions if flagValue is true and customerToGive is not null
            // TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
            jQuery('.cart__checkout-wrapper button[name="checkout"]').text('\n            Checkout\n          ');
              jQuery('.drawer__footer button[name="checkout"],.drawer__footer .cart__checkout-wrapper button[name="checkout"]').text('\n            Checkout\n          ');
           TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);  
          GetCode(false);
        } else {
            // Alert when the checkbox is not checked
            alert("You must agree with the terms and conditions of sales to check out");
        }
  });

        // Delegated handler so the popup's "No thanks" button keeps working after re-renders
        jQuery(document).off('click', '.ac-checkout-NoThanks').on('click', '.ac-checkout-NoThanks', function (e) {
            TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
            GetCode(false);
        });   
}   

 var GetCode = function (isUpper) {
       applyDiscount();
     if (priceDiff > 0 && !flag) {
         jQuery.ajax({
             type: "POST", async: false, url: "https://wholesale.apptiv.in/tier/ACPGenerateDiscountCode",//
             data: { priceDifference: priceDiff, subTotal: minimumDiscountSubtotal, variantIds: variantIdsToSend.toString() },
             success: function (result) {
               flag = true;
                 var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
               
              //  $('.cart__page .cart__checkout-wrapper button[name="checkout"]').text('\n            Check out\n')
              //  $('.cart__page .cart__checkout-wrapper button[name="checkout"]').prop('disabled', false); 
               
             //   $('.drawer__footer button[name="checkout"]').text('\n            Check out\n')
              //  $('.drawer__footer button[name="checkout"]').prop('disabled', false)
               var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
                 SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
                 if (!isUpper) {
                     DiscountCodeCookie(DiscountCode);
                     jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                       window.location.href = '/checkout?discount=' + DiscountCode;
                 } else {
                     DiscountCodeCookie(DiscountCode);
                   setTimeout(() => {
 jQuery('form.cart-form').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
                     window.location.href = '/checkout?discount=' + DiscountCode;
}, 500);

                     
                 }
             },
             error: function (e) { console.log(e.statusText); window.location.href = '/checkout'; }
         });
     }
     else if (isUpper) {
         window.location.href = '/checkout';
     }
   else{
     window.location.href = '/checkout';
   }
 }

 var ReInvokeAjaxCartButton = function () {
     jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
 }

 var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;
   var hide_buttons = null;
   var HideAdditionalPayments = function() {      
   hide_buttons = setInterval(function() {
     if(jQuery('.additional_checkout_buttons, .dynamic-checkout__content').length>0){
       jQuery('.additional_checkout_buttons, .dynamic-checkout__content').hide();
       clearInterval(hide_buttons);
     }
   }, 500);
 }

      function shouldExcludeProduct(productId,excludeProducts) {
    const isExcluded = excludeProducts.some(product => product.id == productId);
    return !isExcluded;
}
  



 
  
 var TieredPricingCart = function (cartObject, isUpdate) {
     variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;
     for (k = 0; k < cartObject.items.length; k++) {
         var item = cartObject.items[k], isInRange = true; itemTiers = GetTiersFromTiersArray(item.variant_id);
          let Vid = item.product_id;
            cartObjFunction();
            if(customerToGive != null){
            itemTiers = customerToGive
            }
            let excludeProduct = true;
            if(itemTiers != undefined && itemTiers.status && itemTiers.excludeProducts != undefined){
            let validatedValue = shouldExcludeProduct(Vid,itemTiers.excludeProducts);
              excludeProduct = validatedValue;
            }
      
       if (itemTiers != undefined && itemTiers.status && globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)&& excludeProduct) {
         
         let DiscountAppliedOn = itemTiers.DiscountAppliedON != null &&  itemTiers.DiscountAppliedON  != '' &&  itemTiers.DiscountAppliedON != undefined ? true : false;
         let Location_Tag_s = itemTiers.Location_Tag_ != null &&  itemTiers.Location_Tag_  != '' &&  itemTiers.Location_Tag_ != undefined ? true : false;
            if(DiscountAppliedOn){
             if(Location_Tag_s){
                let DiscountAppliedOnTag =itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ? true : false;
                let LocationObject = Object.keys(itemTiers.Location_Tag_);
                if(LocationObject[0] == 'StoreLocation'){
                 let StoreLocationcheck =  itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
                 if(StoreLocationcheck && DiscountAppliedOnTag){
                     var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                     updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                     if (rslt[1]) {
                     updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                     }
                   }else{
                   updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                   }
                }else{
                let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
                let CusotmerCountryLocation = globalFields.Customercountry;
                let CusotmerCityLocation = globalFields.Customercity;
                let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                  if(DiscountAppliedOnTag && (CityValue || CountryValue)){
                     var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                     updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                     if (rslt[1]) {
                     updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                     }
                  }else{
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                  }
                }
                                                
              }else{
               if(itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ){
                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
               updatedTotalPrice = rslt[0]; isInRange = rslt[1];
               if (rslt[1]) {
               updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
               }
              }else{
                 updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
              }
              }
              
            }else{
             var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
             updatedTotalPrice = rslt[0]; isInRange = rslt[1];
             if (rslt[1]) {
             updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
             }
              
            }

         
          }
         else {
          UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), true, true, k);
          updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
         }
       
         if (!isInRange) {
             minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
         }
     }
     
     UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100));
     priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
     UpdateSavingMessage(isUpdate);
  jQuery('.cart__checkout-wrapper button[name="checkout"]').text('\n            Checkout\n          ');
  jQuery('.drawer__footer button[name="checkout"],.drawer__footer .cart__checkout-wrapper button[name="checkout"]').text('\n            Checkout\n          ');
       if(priceDiff){
       HideAdditionalPayments();
     }
       setTimeout(function(){
       clearInterval(hide_buttons);
     }, 5000);
   addClassOnImage()
 }
  
setTimeout(function(){
   clearInterval(hide_buttons);
 }, 10000);
 
 var GetTiersFromTiersArray = function (variantId) {
     var tierObj = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.variant_id === variantId); });
     if ( tierObj[0] == undefined || tierObj[0].tiers == "[]") {
         return undefined;
     }
     else {
         return globalFields.GetTierObject(tierObj[0].tiers[0], variantId);
     }
 }

 var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
     for (i = 0; i < itemTiers.tier_min.length; i++) {
         var allVariantItemQty = 0;
         var tierPrice = parseFloat(itemTiers.tier_values[i]);
         var minTier = parseInt(itemTiers.tier_min[i]), maxTier = itemTiers.tier_max[i] != 'max' ? parseInt(itemTiers.tier_max[i]) : itemTiers.tier_max[i];
         var updatedItemPrice = 0, updatedLinePrice = 0, condition1 = false, condition2 = false;

         if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
             var tempItemArray = [];
             if (itemTiers.entity_type === 'collections') {
                 var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].entity_id == itemTiers.entity_id); });
                 for (var m = 0; m < tempTierArray.length; m++) {
                     var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                     if (temp.length != 0) {
                         tempItemArray.push(temp[0]);
                     }
                 }
             }
             else {
                 tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.product_id == item.product_id ); });
             }

             for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
             condition1 = allVariantItemQty >= minTier;
             condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
         }
         else {
             condition1 = item.quantity >= minTier;
             condition2 = maxTier == "max" || item.quantity <= maxTier;
         }

         if (condition1 && condition2) {
             isNotInRange = false;
             if (itemTiers.discount_type == 'percentage') {
                 var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(item.original_price / 100)));
                 updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
             }
             else if (itemTiers.discount_type == 'fixed') {
                 updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - parseFloat(tierPrice));
             }
             else if (itemTiers.discount_type == 'fixed_price') {
                 updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice));
             }

             if (updatedItemPrice < 0) { updatedItemPrice = 0; }
             updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
             updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
             UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index);
         }
     }
     if (isNotInRange) {
         UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
     }
     return [updatedTotalPrice, isNotInRange];
 }

 var DiscountCodeCookie = function (discount_code) {
     jQuery.ajax({
         type: "HEAD", url: "/discount/" + discount_code,
         success: function (_result) { },
         error: function (e) { console.log(e.statusText); }
     })
 }

  var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
               jQuery('.cart__checkout-wrapper button[name="checkout"]').text('\n            Loading..\n          ');
               jQuery('.drawer__footer button[name="checkout"],.drawer__footer .cart__checkout-wrapper button[name="checkout"]').text('\n            Loading..\n          ');
              globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
               cartObjFunction(); 
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
               CheckoutClickCart();
               CheckoutClickAjax();
            },
            error: function (e) { console.log(e.statusText); }
        });
    }
  
 jQuery(document).ajaxComplete(function (event, xhr, settings) {
     ProcessCartResponse(settings.url, xhr.responseText);
 });

      var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
          
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
                globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
                flag = false; // Cart changed - generate a fresh discount code on next checkout
                setTimeout(function () {
                    FetchCartTiers();
                   CheckoutClickCart(); CheckoutClickAjax();cartObjFunction();
                }, 2500);
            }
            else if(splittedUrl[0] == "/cart/add.js"){
               CheckoutClickAjax();
              setTimeout(function () {
            fetch('/cart.js')
                .then(r => r.json().then(data => ({ status: r.status, body: data })))
                .then(obj => {
                    globalFieldsCartPage_AC.cartObj = JSON.parse(JSON.stringify(obj.body));
                  FetchCartTiers();
                });
        }, 1000);
              
              // let valuematch =  JSON.parse(responseText);
              //  if(valuematch.status){
              // setTimeout(function () {
              //       FetchCartTiers();
              //   }, 2000);
              //  }else{
              //   let valuematch =  JSON.parse(responseText);
              //    const targetVariantId = valuematch.variant_id;
              //    const index = globalFieldsCartPage_AC.cartObj.items.findIndex(item => item.variant_id === targetVariantId);
                
              //    if (index !== -1) {
              //       globalFieldsCartPage_AC.cartObj.items[index] = valuematch  
              //   setTimeout(function () {
              //       FetchCartTiers();
              //   }, 2500);
              //    }else{
              //       globalFieldsCartPage_AC.cartObj.items.unshift(valuematch)
              //   setTimeout(function () {
              //       FetchCartTiers();
              //   }, 2500);
              //    }
              //   // globalFieldsCartPage_AC.cartObj.items = globalFieldsCartPage_AC.cartObj.items.reverse()
              //  }
            
            }
        }
    }
  
 // var ProcessCartResponse = function (splittedUrl, responseText) {
 //     if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
 //         splittedUrl = splittedUrl.split("?");
 //         if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
 //              jQuery('#cart-notification button[name="checkout"],.drawer__footer button[name="checkout"]').text('\n            Loading...\n          ');
 //              jQuery('.cart__checkout-button.button').text('\n            Loading...\n          ');
 //             globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
 //             setTimeout(function () {
 //                 FetchCartTiers();
                 
 //                 CheckoutClickAjax();
 //             }, 1200);
 //         }
 //     }
 // }

 try{
     var nativeFetch = window.fetch;
     window.fetch = function(...args) {
       if(args[0].includes("/cart/change") || args[0].includes("/cart/add")){
         setTimeout(function () {
           fetch('/cart.js')
           .then(r =>  r.json().then(data => ({status: r.status, body: data})))
           .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
         }, 800);
       }
       return nativeFetch.apply(window, args);
     }
   }
   catch(e){}


  function addClassOnImage() {
       setTimeout(function(){   
                    $('.drawer__inner .cart__item image-element').each(function(){
                    if (!$(this).hasClass('aos-animate')) {
                    $(this).addClass('aos-animate');
                    }
                    });
                     }, 1000);
  }

  


    // Call the function to initiate the fetch and handle the promise
 async function applyDiscount() {
  await handleDiscount();
  // This runs only after handleDiscount() is resolved
  console.log("Discount completed");
}
applyDiscount();
 var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }
 let start = null;
    let requestInterval = function() {      
      start = setInterval(function() {
      TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
      }, 2000);
    }
    requestInterval();
    setTimeout(function(){
      clearInterval(start);
    }, 16000);

    window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    window.location.reload();
  }
});

 TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();cartObjFunction();
}

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();